// Cattle calving-record delete API. Uses a transactional SECDEF RPC that
// deletes the row and logs a record.deleted Activity event (scoped to the
// dam's cattle.animal record) in one transaction — no bare client delete.

import type {RpcEnvelope, SupabaseClient} from './supabaseTypes.js';

export async function deleteCattleCalvingRecord(
  sb: SupabaseClient,
  recordId: string,
  teamMember?: string | null,
): Promise<RpcEnvelope> {
  if (!sb) throw new Error('deleteCattleCalvingRecord: sb required');
  const {data, error} = await sb.rpc('delete_cattle_calving_record', {
    p_record_id: recordId,
    p_team_member: teamMember || null,
  });
  if (error) throw new Error(`deleteCattleCalvingRecord: ${error.message || String(error)}`);
  return data;
}
